module.exports = __webpack_public_path__ + "img/1482868093.486bdca5.jpg";